import * as React from 'react';

import { Icon } from './icon';
import { cn } from '@/new/lib/utils';

export interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(({ className, ...props }, ref) => {
  return (
    <div
      className={cn(
        'flex items-center rounded-lg border border-gray-300 bg-white duration-150 focus-within:border-gray-400',
        className,
      )}
    >
      <Icon className="lucide--search mx-3 text-base text-gray-400" />
      <input
        ref={ref}
        type="text"
        className="w-full py-2 text-sm text-gray-900 outline-none placeholder:text-gray-400 focus:outline-none"
        {...props}
      />
    </div>
  );
});
SearchInput.displayName = 'SearchInput';
